var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","xs":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('v-img',{attrs:{"src":require("../assets/showcase.jpeg"),"height":"100vh"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }